import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/client/Navbar";
import Footer from "../components/client/Footer";
import FloatingCTAs from "../components/client/FloatingCTAs";
import ScrollToTopButton from "../components/client/ScrollToTopButton";
import ScrollToTop from "../components/client/ScrollToTop";

const RouteFallback = () => (
  <div className="min-h-[60vh] w-full bg-black" aria-hidden="true" />
);

const ClientLayout = () => {
  return (
    <>
      <Navbar />
      <main>
        <ScrollToTop />
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <FloatingCTAs />
      <ScrollToTopButton />
    </>
  );
};

export default ClientLayout;